import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Collapse, Modal, Button, Alert } from "react-bootstrap";

const ConstitutionAdmin = () => {
  const [collapseBtn, setCollapseBtn] = useState(true);
  const [pages, setPages] = useState([]);

  const [formData, setFormData] = useState({
    order_no: "",
  });

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  // PROFESSIONAL ALERT
  const [alert, setAlert] = useState({
    show: false,
    type: "",
    text: "",
  });

  // DELETE CONFIRM MODAL
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // EDIT STATE
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editImage, setEditImage] = useState(null);
  const [editData, setEditData] = useState({
    order_no: "",
    image: "",
  });

  // SHOW ALERT
  const showAlert = (type, text) => {
    setAlert({ show: true, type, text });
    setTimeout(() => {
      setAlert({ show: false, type: "", text: "" });
    }, 3000);
  };

  // FETCH PAGES
  const fetchPages = async () => {
    try {
      const res = await fetch("https://admin.vascularirdoctors.com/backend/constitution");
      const data = await res.json();
      setPages(data);
    } catch (err) {
      console.log("FETCH CONSTITUTION ERROR:", err);
      showAlert("danger", "Unable to fetch constitution pages.");
    }
  };

  useEffect(() => {
    fetchPages();
  }, []);

  // FORM CHANGE
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImage = (e) => {
    setImage(e.target.files[0]);
  };

  // ADD PAGE
  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      data.append("order_no", formData.order_no);
      if (image) data.append("image", image);

      const res = await fetch("https://admin.vascularirdoctors.com/backend/constitution", {
        method: "POST",
        body: data,
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Constitution page added successfully.");
        setFormData({
          order_no: "",
        });
        setImage(null);

        // Reset file input visually
        const fileInput = document.getElementById("constitutionImageInput");
        if (fileInput) fileInput.value = "";

        fetchPages();
      } else {
        showAlert("danger", result.message || "Failed to add constitution page.");
      }
    } catch (err) {
      console.log("CONSTITUTION SUBMIT ERROR:", err);
      showAlert("danger", "Unable to connect to server.");
    }

    setLoading(false);
  };

  // DELETE PAGE
  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const deletePage = async () => {
    try {
      const res = await fetch(`https://admin.vascularirdoctors.com/backend/constitution/${deleteId}`, {
        method: "DELETE",
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Constitution page deleted successfully.");
        fetchPages();
      } else {
        showAlert("danger", result.message || "Delete failed.");
      }
    } catch (err) {
      console.log("DELETE ERROR:", err);
      showAlert("danger", "Unable to delete constitution page.");
    }

    setShowDeleteModal(false);
    setDeleteId(null);
  };

  // OPEN EDIT
  const openEditModal = (page) => {
    setEditId(page.id);
    setEditData({
      order_no: page.order_no || "",
      image: page.image || "",
    });
    setEditImage(null);
    setShowModal(true);
  };

  // EDIT INPUT CHANGE
  const handleEditChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditImage = (e) => {
    setEditImage(e.target.files[0]);
  };

  // UPDATE PAGE
  const updatePage = async () => {
    try {
      const data = new FormData();
      data.append("order_no", editData.order_no);
      if (editImage) data.append("image", editImage);

      const res = await fetch(`https://admin.vascularirdoctors.com/backend/constitution/${editId}`, {
        method: "PUT",
        body: data,
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Constitution page updated successfully.");
        setShowModal(false);
        fetchPages();
      } else {
        showAlert("danger", result.message || "Update failed.");
      }
    } catch (err) {
      console.log("UPDATE ERROR:", err);
      showAlert("danger", "Unable to update constitution page.");
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row page-titles align-items-center">
            <div className="col-sm-6">
              <ol className="breadcrumb mt-sm-0 mt-2">
                
                <li className="breadcrumb-item active" aria-current="page">
                  Constitution Pages
                </li>
              </ol>
            </div>

            {/* TOP RIGHT CLOSE BUTTON */}
            <div className="col-sm-6 text-sm-end mt-2 mt-sm-0">
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={() => setCollapseBtn(false)}
              >
                <i className="fas fa-times me-1"></i> Close
              </button>
            </div>
          </div>
        </div>

        {/* ALERT */}
        {alert.show && (
          <div className="col-xl-12">
            <Alert variant={alert.type} className="shadow-sm rounded-3">
              {alert.text}
            </Alert>
          </div>
        )}

        {/* ADD FORM */}
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className="content-title d-flex justify-content-between align-items-center">
              <div className="cpa">
                <i className="fas fa-file-pdf me-1"></i>Add Constitution Page
              </div>
              <div className="tools">
                <button
                  type="button"
                  className="btn btn-sm btn-light border"
                  onClick={() => setCollapseBtn(!collapseBtn)}
                >
                  <i
                    className={`fas ${
                      collapseBtn ? "fa-angle-up" : "fa-angle-down"
                    }`}
                  ></i>
                </button>
              </div>
            </div>

            <Collapse in={collapseBtn}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <form onSubmit={submitHandler}>
                    <div className="row">
                      <div className="col-xl-6">
                        <div className="mb-3">
                          <label className="form-label">Page Order Number</label>
                          <input
                            type="number"
                            className="form-control"
                            name="order_no"
                            value={formData.order_no}
                            onChange={handleChange}
                            placeholder="Example: 1, 2, 3..."
                            required
                          />
                          <small className="text-muted">
                            Lower number appears first in PDF.
                          </small>
                        </div>
                      </div>

                      <div className="col-xl-6">
                        <div className="mb-3">
                          <label className="form-label">Upload Page Image</label>
                          <input
                            id="constitutionImageInput"
                            type="file"
                            className="form-control"
                            onChange={handleImage}
                            accept="image/*"
                            required
                          />
                        </div>

                        {image && (
                          <div className="mb-3">
                            <img
                              src={URL.createObjectURL(image)}
                              alt="Preview"
                              style={{
                                width: "100%",
                                maxHeight: "300px",
                                objectFit: "contain",
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                                background: "#fff",
                                padding: "10px",
                              }}
                            />
                          </div>
                        )}
                      </div>

                      <div className="col-xl-12 text-end">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save Constitution Page"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Collapse>
          </div>
        </div>

        {/* PAGE LIST */}
        <div className="col-xl-12 mt-4">
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">
                <i className="fas fa-images me-1"></i>Uploaded Constitution Pages
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead>
                    <tr>
                      <th style={{ width: "90px" }}>Preview</th>
                      <th>Page Order</th>
                      <th>Image Path</th>
                      <th style={{ width: "170px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pages.length > 0 ? (
                      pages.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <img
                              src={
                                item.image
                                  ? `https://admin.vascularirdoctors.com/backend${item.image}`
                                  : "https://via.placeholder.com/90x120?text=No+Image"
                              }
                              alt={`Page ${item.order_no}`}
                              style={{
                                width: "70px",
                                height: "90px",
                                objectFit: "cover",
                                borderRadius: "8px",
                                border: "1px solid #ddd",
                              }}
                            />
                          </td>
                          <td>{item.order_no}</td>
                          <td>{item.image}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-info me-2"
                              onClick={() => openEditModal(item)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => confirmDelete(item.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No constitution pages found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Constitution Page</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12 mb-3">
              <label>Page Order Number</label>
              <input
                type="number"
                className="form-control"
                name="order_no"
                value={editData.order_no}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-12 mb-3">
              <label>Change Page Image</label>
              <input
                type="file"
                className="form-control"
                onChange={handleEditImage}
                accept="image/*"
              />
            </div>

            <div className="col-md-12">
              <img
                src={
                  editImage
                    ? URL.createObjectURL(editImage)
                    : editData.image
                    ? `https://admin.vascularirdoctors.com/backend${editData.image}`
                    : "https://via.placeholder.com/600x800?text=No+Image"
                }
                alt="Preview"
                style={{
                  width: "100%",
                  maxHeight: "500px",
                  objectFit: "contain",
                  borderRadius: "10px",
                  background: "#fff",
                  border: "1px solid #ddd",
                  padding: "10px",
                }}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={updatePage}>
            Update Page
          </Button>
        </Modal.Footer>
      </Modal>

      {/* DELETE CONFIRM MODAL */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Constitution Page</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this constitution page? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={deletePage}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConstitutionAdmin;